import { Button } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import clipboard from "@/assets/clipboard.svg";

type AccessTokenProps = {
	appObject: {
		appToken: string;
		companyToken: string;
		createdAt: string;
		id: number;
		name: string;
		nextPaymentAt: null | string;
		packageAndroid: string;
		packageIos: string;
	};
	translationObject: any;
};
function AccessToken({ appObject, translationObject }: AccessTokenProps) {
	const { enqueueSnackbar } = useSnackbar();
	return (
		<div style={{ margin: "3rem 2rem 1rem 2rem" }}>
			<div
				className="MainSection__Container"
				style={{ border: "2px solid #E0E0E0", backgroundColor: "#FFFFFF" }}
			>
				<div
					className="ApplicationName"
					style={{
						display: "flex",
						alignItems: "center",
						padding: "1.5rem",
					}}
				>
					<span
						style={{
							fontWeight: "bold",
							width: "40%",
							display: "inline-block",
						}}
					>
						{translationObject("application_setting.company_token")}
					</span>
					<CopyToClipboard
						text={appObject.companyToken}
						onCopy={() => {
							enqueueSnackbar(
								translationObject(
									"application_setting.clip_board_copy_company_token",
								),
								{
									variant: "info",
								},
							);
						}}
					>
						<Button
							variant="outlined"
							sx={{
								width: "60%",
								color: "rgba(0, 0, 0, 0.38)",
								backgroundColor: "rgb(224 224 224)",
								borderColor: "rgba(0, 0, 0, 0.38)",
								overflowX: "hidden",
								textTransform: "none",
							}}
						>
							{appObject.companyToken}{" "}
							<img
								src={clipboard}
								alt="사진없음"
								style={{ marginLeft: "auto" }}
							/>
						</Button>
					</CopyToClipboard>
				</div>
				<div style={{ border: "1px solid #E0E0E0" }} />
				<div
					className="ApplicationName"
					style={{
						display: "flex",
						alignItems: "center",
						padding: "1.5rem",
					}}
				>
					<span
						style={{
							fontWeight: "bold",
							width: "40%",
							display: "inline-block",
						}}
					>
						{translationObject("application_setting.app_token")}
					</span>
					<CopyToClipboard
						text={appObject.appToken}
						onCopy={() => {
							enqueueSnackbar(
								translationObject(
									"application_setting.clip_board_copy_access_token",
								),
								{
									variant: "info",
								},
							);
						}}
					>
						<Button
							variant="outlined"
							sx={{
								width: "60%",
								color: "rgba(0, 0, 0, 0.38)",
								backgroundColor: "rgb(224 224 224)",
								borderColor: "rgba(0, 0, 0, 0.38)",
								overflowX: "hidden",
								textTransform: "none",
							}}
						>
							{appObject.appToken}
							<img
								src={clipboard}
								alt="no_image"
								style={{ marginLeft: "auto" }}
							/>
						</Button>
					</CopyToClipboard>
				</div>
			</div>
		</div>
	);
}

export default AccessToken;
